var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100"},_vm._l((_vm.messages),function(msg,i){return _c('div',{key:i,staticClass:"alert alert-info m-0 pa-1 w-100"},[_vm._v(" "+_vm._s(_vm.$t(msg.message, msg.message))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }